<template>
  <div class="header">
    <div class="content-wrap flex flex-between">
      <a class="logo" href="/">
        <img v-if="userStore.userInfo.source === 0 && !userStore.userInfo.ico && userStore.userInfo.schoolId !== 530243" src="@/assets/images/logo.png" alt="logo" />
        <span class="school-name">
          {{ userStore.userInfo.schoolId !== 530243 ? userStore.userInfo.schoolName : '' }}
        </span>
      </a>
      <div class="menu">
        <router-link v-if="auth !== 1" class="menu-item" :class="{ 'router-link-exact-active': props.parent == 'Task' }"
          to="/task">考试管理</router-link>
        <router-link class="menu-item" :class="{ 'router-link-exact-active': props.parent == 'OnlineCheck' }"
          to="/onlineCheck">网上阅卷</router-link>
        <a class="menu-item" @click="handleButtonClick">学业评价</a>
        <router-link v-if="auth === 3" class="menu-item"
          :class="{ 'router-link-exact-active': props.parent == 'System' }" to="/system">系统设置</router-link>
      </div>
      <div class="userInfo">
        {{ userStore.userInfo.name }}
        <span class="ml10 text-white pointer" @click="logout" v-show="userStore.userInfo.source === 0 && !userStore.userInfo.ico">退出</span>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { useUserStore } from "@/store";
import { computed } from "vue";
import { useRouter } from "vue-router";
import { request } from "@/services";

const router = useRouter();
const userStore = useUserStore();
const props = defineProps({
  parent: {
    type: String,
    default: "",
  },
});
const auth = computed(() => {
  /**
   *  1.当响应的用户角色(type)==0 && 角色权限(customRole)==null  只显示网上阅卷模块  此时用户的角色为普通老师
      2.当响应的用户角色(type)==0 && 角色权限(customRole)!=null  只显示网上阅卷+考试管理模块  此时用户的角色为普通老师，但管理员给与给老师自定义角色权限
      3.当响应的用户角色(type)==1  显示网上阅卷+考试管理+系统设置模块  此时用户的角色为学校管理员
   */
  if (userStore.userInfo.type == 1) {
    return 3;
  } else if (userStore.userInfo.type == 0 && userStore.userInfo.customRole == null) {
    return 1;
  } else {
    return 2;
  }
});
const logout = () => {
  userStore.logout();
  // 跳转到登录页面
  router.replace({ name: "Login" });
};
const handleButtonClick = async () => {
  request.get("/common/open-app", { params: { type: 2, scoreType: 3 } }).then((res) => {
    if (res.code === 200) {
      window.open(res.data, "_blank");
    }
  });
};
</script>
